import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import AddServicesUnits from '../../../../models/AddServicesUnits';

import { formatCurrency } from '../../../../utils/currencyFormatter';

import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({


});

interface BupBreakdown20ftProps {
  classes: any;
  serviceDetails: AddServicesUnits
};

const BupBreakdown20ft = (props: BupBreakdown20ftProps) => {

  const { classes, serviceDetails } = props;

  return (

    <div className={ commonStyles.inputLabelWrapper } >
      <label className={ commonStyles.inputLabel }> Cost Per Unit </label>
      <TextField
        disabled
        label=""
        defaultValue={ formatCurrency(serviceDetails.cost_usd ? serviceDetails.cost_usd : 0, 2, '$') + ' / Main deck 20ft' }
        variant="outlined"
        inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
        InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
        InputLabelProps={{ style: { fontWeight: 'bold' } }}
        fullWidth
      />
    </div>
    
  );
}

export default withStyles(styles)(BupBreakdown20ft);